function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState, useEffect, useRef, useCallback, forwardRef } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import DateCommon from '../DateCommon';

const Range = ({
  value,
  onChange,
  placeholderStart,
  placeholderEnd,
  ...props
}) => {
  const [startDate, endDate] = Array.isArray(value) ? value : [];
  const [states, setStates] = useState({
    startDate,
    endDate
  });
  const ready = useRef(false);
  const endRef = useRef(null); // useEffect(() => {
  //     if(ready.current) {
  //         endRef.current?.focus()
  //     }
  // }, [states.startDate && states.startDate.getTime()])

  useEffect(() => {
    if (ready.current) {
      const target = {
        name: props.name,
        value: [states.startDate, states.endDate]
      };
      onChange && onChange({ ...target,
        target
      });
    } else {
      ready.current = true;
    }
  }, [states]);

  const handleStartChange = event => {
    setStates(prev => ({ ...prev,
      startDate: event.value
    }));
  };

  const handleEndChange = event => {
    setStates(prev => ({ ...prev,
      endDate: event.value
    }));
  };

  const Custom = useCallback( /*#__PURE__*/forwardRef((props, ref) => {
    const handleRef = node => {
      ref.current = node;
      endRef.current = node;
    };

    return /*#__PURE__*/React.createElement("input", _extends({
      ref: handleRef
    }, props));
  }), []);
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(DateCommon, _extends({}, props, {
    selectsStart: true,
    value: startDate,
    startDate: startDate,
    endDate: endDate,
    onChange: handleStartChange,
    placeholder: placeholderStart
  }))), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(DateCommon, _extends({}, props, {
    selectsEnd: true,
    value: endDate,
    startDate: startDate,
    endDate: endDate,
    minDate: startDate,
    onChange: handleEndChange,
    placeholder: placeholderEnd,
    customInput: /*#__PURE__*/React.createElement(Custom, null)
  }))));
};

Range.defaultProps = {
  value: []
};
export default Range;